module.exports = __webpack_public_path__ + "images/cos-cb9f8005b1d0f954b546fc1cecb45de6.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cos.png
// module id = 205
// module chunks = 0